define('controllers/conversations/Podio.Controllers.Conversations.List',['require','underscore','lib/backbone/Backbone.PodioController','controllers/conversations/Podio.Controllers.Conversations.Show','root/audio_video/Podio.UI.AudioVideo.GTMFree','lib/Podio.Utils'],function(require) {

  var _ = require('underscore');
  var PodioController = require('lib/backbone/Backbone.PodioController');
  var ControllerConversationShow = require('controllers/conversations/Podio.Controllers.Conversations.Show');
  var AudioVideoGTMFree = require('root/audio_video/Podio.UI.AudioVideo.GTMFree');
  var utils = require('lib/Podio.Utils');

  return PodioController.extend({

    initialize: function(options) {

      _.bindAll(this, 'onConversationClicked', 'onAddParticipants', 'onLeftConversation');

      this._super();

      this.elmTarget = options.elmTarget;
      this.mainViewClass = options.mainViewClass;
      this.listViewClass = options.listViewClass;
      this.elmMainViewTarget = options.elmMainViewTarget;
      this.conversationCollectionController = options.conversationCollectionController;

      this.conversationsShowController = new ControllerConversationShow({
        mainViewClass: this.mainViewClass,
        elmMainViewTarget: this.elmMainViewTarget,
        presenceFeatures: options.presenceFeatures,
        eventBus: this.eventBus,
        conversationsCollectionController: this.conversationCollectionController
      });

      this._bindEvents();
    },

    _bindEvents: function() {
      this.listenTo(this.eventBus, 'conversation:click', this.onConversationClicked);
      this.listenTo(this.eventBus, 'showConversation:addParticipants', this.onAddParticipants);
      this.listenTo(this.eventBus, 'showConversation:messageSubmitted', this.onAddMessage);
      this.listenTo(this.eventBus, 'showConversation:leftConversation', this.onLeftConversation);
      this.listenTo(this.eventBus, 'conversation:markUnread', this.onConversationMarkedUnread);
      this.listenTo(this.eventBus, 'showConversation:markUnread', this.onConversationMarkedUnread);
      this.listenTo(this.eventBus, 'conversation:starred', this.onConversationStarred);
      this.listenTo(this.eventBus, 'conversation:unstarred', this.onConversationUnstarred);
      this.listenTo(this.eventBus, 'showConversation:star', this.onConversationStarred);
      this.listenTo(this.eventBus, 'showConversation:unstar', this.onConversationUnstarred);
      this.listenTo(this.eventBus, 'showConversation:subjectChanged', this.onSubjectChanged, this);
      this.listenTo(this.eventBus, 'showConversation:messageDeleted', this.onAddMessage); // This will remove excerpt if very last message is deleted.
    },

    onConversationClicked: function(conversation) {
      this.showConversation(conversation);
    },

    renderList: function(options) {
      var self = this;

      if (this.conversationsListView) {
        this.conversationsListView.dispose();
      }

      this.conversationsListView = new this.listViewClass({
        elmTarget: this.elmTarget,
        eventBus: this.eventBus,
        sharedState: this.options.sharedState,
        headerCounters: this.options.headerCounters
      });

      this.conversationsListView.renderWaiting();

      // If we have an existing deferred, this method is being called multiple times very fast. Cancel the old deferred then.
      if (this.dfdRenderList) {
        this.dfdRenderList.reject();
      }

      this.dfdRenderList = this.conversationCollectionController.getConversations(options);
      this.dfdRenderList.done(function(collection) {
        delete self.dfdRenderList;
        if (self.conversationsListView) {
          self.conversationsListView.setCollection(collection);
          if ( self.conversationsListView.scrollToTop ) { self.conversationsListView.scrollToTop(); }
          self.conversationsListView.render();
          if ( self.conversationsListView.initPagination ) { self.conversationsListView.initPagination(); }
          if ( self.conversationsListView.loadHeightFillingItems ) { self.conversationsListView.loadHeightFillingItems(); }
        }
      });

      return this.dfdRenderList;
    },

    showConversation: function(conversation, options) {
      var self = this;
      options = options || {};

      if (options.forceRender || !this.conversationsShowController.conversation || this.conversationsShowController.conversation.get('id') !== conversation.get('id')) {
        this.conversationsShowController.indicateConversationLoading();
        this.conversationCollectionController.getConversationEvents(conversation.get('id'), { forceFetch: options.reloadEvents }).done(function(collection) {
          self.conversationsShowController.setConversation(conversation, collection);
          self.conversationsShowController.renderConversation(options);

          if (options.setSelected) {
            self.conversationsListView.setSelectedConversation(conversation, null, options);
          }

          if (conversation.isUnread()) {
            conversation.markRead();
            self.conversationCollectionController.removeConversationFromSingleCollection(conversation, 'unread', { silent: true });
            self.trigger('conversationsListController:markRead');
          }
        });
      }
    },

    markAllRead: function() {
      this.conversationsListView.markAllRead();
    },

    onAddParticipants: function(conversation, participants) {
      this.conversationCollectionController.addParticipants(
        conversation.get('id'),
        participants
      );
      this.conversationCollectionController.refetchConversation(conversation);
    },

    onAddMessage: function(conversation) {
      this.conversationCollectionController.refetchConversation(conversation);
    },

    onSubjectChanged: function(conversation, subject) {
      this.conversationCollectionController.changeSubject(
        conversation.get('id'),
        subject
      );
      conversation.set({ subject: subject });
    },

    onLeftConversation: function(conversation) {
      this.conversationCollectionController.leaveConversation(conversation);
    },

    onConversationMarkedUnread: function(model) {
      this.conversationCollectionController.addConversationToSingleCollection(model, 'unread');
    },

    onConversationStarred: function(model) {
      this.conversationCollectionController.addConversationToSingleCollection(model, 'starred');
    },

    onConversationUnstarred: function(model) {
      this.conversationCollectionController.removeConversationFromSingleCollection(model, 'starred', { silent: true });
    },

    indicateConversationLoading: function() {
      this.conversationsShowController.indicateConversationLoading();
    },

    dispose: function() {
      this._super();
      //this.stopListeningToEventBus();
      this.stopListening();

      this.conversationsShowController.dispose();
      delete this.conversationsShowController;

      if (this.conversationsListView) {
        this.conversationsListView.dispose();
        delete this.conversationsListView;
      }
    }

  });

});

